module.exports = __webpack_public_path__ + "static/media/parking.3b0d48bd.svg";